import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Line, Stroke } from '../../types';

@Component({
  selector: 'g[svg-line]',
  templateUrl: './svgline.component.html',
  styleUrls: ['./svgline.component.css']
})
export class SvgLineComponent implements OnInit {



  constructor() { }


  @Input()
  public line: Line;

  @Output()
  public lineMousedown = new EventEmitter<{ mouseEvent: MouseEvent, line: Line }>();

  @Output()
  public lineMouseover = new EventEmitter<{ mouseEvent: MouseEvent, line: Line }>();

  ngOnInit() {
    if (!this.line.stroke) {
      this.line.stroke = new Stroke();
    }
  }

  public onLineMouseDown($event): void {
    if ($event) {
      this.lineMousedown.emit({ mouseEvent: $event, line: this.line });
    }
  }

  public onLineMouseOver($event): void {
    if ($event) {
      this.lineMouseover.emit({ mouseEvent: $event, line: this.line });
    }
  }
}
